module.exports = __webpack_public_path__ + "img/SKMJ_nousb.236f51ac.png";